import { Directive, ElementRef, Inject, OnInit } from '@angular/core';
import { THEME_TOKEN, Theme } from '../../types/theme.types';
import { componentStylesByTheme } from '../../utils/theme.utils';
import {
  stepperKnobStylesSAG,
  stepperKnobStylesSHS,
} from './stepper-knob.styles';
import { updateElementStyles } from '../../utils/style.utils';

@Directive({
  selector: '[sag-ui-stepper-knob]',
})
export class StepperKnobDirective implements OnInit {
  constructor(
    @Inject(THEME_TOKEN) private readonly theme: Theme,
    private readonly elementRef: ElementRef<HTMLInputElement>,
  ) {}

  private applyStyles(): void {
    const styles = componentStylesByTheme(
      this.theme,
      stepperKnobStylesSAG,
      stepperKnobStylesSHS,
    );

    updateElementStyles(this.elementRef, styles());
  }

  ngOnInit(): void {
    this.applyStyles();
  }
}
